<template>
    <div>
<!--        <breadcrumb :routerList="[{to:'/xuqiu/Lmanagement',title:'协同管理'},{title:'协同部门配置'}]"/>-->
      <Breadtabsheader/>
        <div class="h-content">
            <div class="h-piece">
                <div class="h-formBox">
                    <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
                        <div class="h-thirdColumn w-newColumn">
                            <el-form-item label="供应商名称" >
                              <el-input v-model="q.supplierName" placeholder="请输入名称/编码" :clearable="true"></el-input>
                            </el-form-item>
                            <el-form-item label="产品编码" >
                              <el-input v-model="q.prodcode" placeholder="请输入编码" :clearable="true"></el-input>
                            </el-form-item>
                            <el-form-item label="产品型号" >
                              <el-input v-model="q.promodel" placeholder="请输入型号" :clearable="true"></el-input>
                            </el-form-item>
                            <el-form-item label="状态">
                              <el-select v-model="q.status" placeholder="请选择">
                                <el-option label="冻结" value="0"></el-option>
                                <el-option label="正常" value="1"></el-option>
                              </el-select>
                            </el-form-item>
                        </div>
                      <div class="l-screenBox">
                        <div class="l-retrieval">
                          <el-form-item>
                            <el-button class="h-btn h-formBtn" @click="query">检索</el-button>
                            <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置
                            </el-button>
                            <el-button class="h-btn h-formBtn h-bggreen" icon="el-icon-plus"
                                       @click="adduser">新增
                            </el-button>
                          </el-form-item>
                        </div>
                      </div>
                    </el-form>
                </div>
            </div>
            <div class="h-row">
                <div class="h-rowIn" style="width:100%;">
                    <el-table @selection-change="handleSelectionChange"
                              ref="multipleTable"
                              :data="tableData"
                              :border="true"
                              stripe
                              max-height="500"
                              style="width: 100%">
                        <el-table-column
                                type="selection"
                        >
                        </el-table-column>
                        <el-table-column
                                type="index"
                                label="#">
                        </el-table-column>
                        <el-table-column
                                prop="prodseries"
                                :show-overflow-tooltip="true"
                                width="100"
                                label="产品大类">
                        </el-table-column>
                        <el-table-column
                                prop="procategory"
                                :show-overflow-tooltip="true"
                                width="100"
                                label="二级分类">
                        </el-table-column>
                        <el-table-column
                                prop="promodel"
                                :show-overflow-tooltip="true"
                                width="100"
                                label="产品型号">
                        </el-table-column>
                      <el-table-column
                          prop="prodcode"
                          :show-overflow-tooltip="true"
                          width="100"
                          label="产品编码">
                      </el-table-column>
                      <el-table-column
                          prop="supplierCode"
                          label="供应商编码"
                          width="120"
                          :show-overflow-tooltip="true">
                      </el-table-column>
                      <el-table-column
                          prop="supplierName"
                          :show-overflow-tooltip="true"
                          width="120"
                          label="供应商名称">
                      </el-table-column>
                      <el-table-column
                          prop="totalPrice"
                          :show-overflow-tooltip="true"
                          width="100"
                          label="金额">
                      </el-table-column>
                      <el-table-column
                          prop="currency"
                          :show-overflow-tooltip="true"
                          width="100"
                          label="币种">
                        <template slot-scope="scope">
                          {{scope.row.currency | dictname('YLCurrency')}}
                        </template>
                      </el-table-column>
<!--                      <el-table-column
                          prop="paymentNodeName"
                          :show-overflow-tooltip="true"
                          width="120"
                          label="付款节点">
                      </el-table-column>-->
                      <el-table-column
                          prop="taxRate"
                          :show-overflow-tooltip="true"
                          width="100"
                          label="税率">
                        <template slot-scope="scope">
                          <dictname category="cgshuilv" :v="scope.row.taxRate"/>
                        </template>
                      </el-table-column>
                      <el-table-column
                          prop="des"
                          :show-overflow-tooltip="true"
                          width="100"
                          label="描述">
                      </el-table-column>
                      <el-table-column
                          prop="status"
                          :show-overflow-tooltip="true"
                          label="状态">
                        <template slot-scope="scope">
                          <div v-if="scope.row.status=='1'">正常</div>
                          <div v-if="scope.row.status=='0'" >冻结</div>
                        </template>
                      </el-table-column>
                      <el-table-column
                              fixed="right"
                              label="操作"
                              width="100">
                          <template slot-scope="scope">
                              <div class="w-caozuo" style="text-align: left;">
                                  <el-button
                                      type="text"
                                      size="small"
                                      class="h-tableLink h-btn" @click="cheak(scope.row)">
                                    查看
                                  </el-button>
                                  <el-button
                                          type="text"
                                          size="small"
                                          class="h-tableLink h-btn" @click="update(scope.row)">
                                      修改
                                  </el-button>
                              </div>
                          </template>
                      </el-table-column>
                    </el-table>
                    <div class="h-tableB h-mrt30">
                        <div class="h-tableBL">
                            <el-button :v-if="this.multipleSelection.length === 0" class="h-btn h-formBtn h-bgblueQ"
                                       icon="h-el-icon h-el-icon-delete" @click="deleteSelete">批量删除
                            </el-button>
                            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                                       @click="exportExcel">批量导出
                            </el-button>
                            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-export" v-if="isImport"
                                       @click="uploaddownexcelflagbtn">批量导入
                            </el-button>
                            <uploaddownexcel
                                    :visible.sync="uploaddownexcelflag"
                                    v-if="uploaddownexcelflag"
                                    clsname="bscSupplierProductCompareExcel"
                                    :startrow="2"
                                    :extparams="q"
                                    @callback="uploadExcelFilecallback"/>
                        </div>
                        <div class="h-pagination2">
                            <pagination :page="q" @query="query"/>
                        </div>
                    </div>
                </div>
            </div>
            <!--新增-->
          <el-dialog :close-on-click-modal="false" :visible.sync="dialogFormVisibleAdd" class="h-dialog2 yonghu" @close="cancel('f')">
            <div class="h-dialogImg">
              <div class="h-disTable">
                <div class="h-tableCell" v-if="this.saveorupdate==1">
                  <h1>新增信息</h1>
                  <p>New</p>
                </div>
                <div class="h-tableCell" v-if="this.saveorupdate==2">
                  <h1>修改信息</h1>
                  <p>Update</p>
                </div>
              </div>
            </div>
            <div class="h-formLine h-mrb-38">
              <el-form :model="f" :rules="rules" ref="f"
                       :inline="true" class="demo-ruleForm h-formbLine h-dialogForm dialogForms">
                <el-form-item label="产品编码" class="h-elformWrap-2" prop="areaCode">
                  <el-select v-model="f.prodcode" remote filterable :filter-method="getProduct" clearable
                             placeholder="请输入"
                             :remote-method="getProduct" @change="getProduct">
                    <el-option v-for="(item) in productList"
                               :key="item.prodcode"
                               :label="item.prodcode"
                               :value="item.prodcode">
                    </el-option>
                  </el-select>

                </el-form-item>

                <el-form-item label="产品型号" class="h-elformWrap-2" prop="areaCode">
                  <el-input  placeholder="输入产品编码自动带出" :v="f.promodel" v-model="f.promodel" :clearable="true" readonly
                  />
                </el-form-item>

                <el-form-item label="产品大类" class="h-elformWrap-2" prop="areaCode">
                  <el-input placeholder="输入产品编码自动带出" v-model="f.prodseries" readonly></el-input>
                </el-form-item>

                <el-form-item label="二级分类" class="h-elformWrap-2" prop="areaCode">
                  <el-input  placeholder="输入产品编码自动带出" :v="f.procategory" v-model="f.procategory" :clearable="true" readonly
                  />
                </el-form-item>

                <el-form-item label="金额" class="h-elformWrap-2" prop="totalPrice">
                  <el-input :v="f.totalPrice" v-model="f.totalPrice" :clearable="true" placeholder="请输入数字"
                  />
                </el-form-item>

                <el-form-item label="币种" class="h-elformWrap-2" prop="currency">
                  <brselect category="YLCurrency" :v="f.currency" v-model="f.currency" :clearable="true"
                  />
                </el-form-item>
                <el-form-item label="税率" class="h-elformWrap-2" prop="taxRate">
                  <brselect category="cgshuilv" :v="f.taxRate" v-model="f.taxRate" :clearable="true"
                  />
                </el-form-item>
                <el-form-item label="描述" class="h-elformWrap-2" prop="des">
                  <el-input :v="f.des" v-model="f.des" :clearable="true"
                  />
                </el-form-item>

                <div>
                  <el-button @click="addFukuan()" type="text" size="mini"
                             style="float:right;font-size:20px;margin-right: -5px" icon="el-icon-circle-plus"
                             circle></el-button>

                  <div v-for="(listIt, index) in f.payments" :key="index" class="h-formBox">
                    <el-button @click="deleteFukuan(index)" v-show="index != 0" type="text"
                               style="float:right;font-size:20px;margin-right: -5px;color:crimson;" size="mini"
                               icon="el-icon-remove" circle></el-button>


                    <div style="width: 100%">
                    <el-form-item prop="paymentNode" label="付款节点" class="h-elformWrap-fukuan " >
                      <brselect category="payment_node" :v="f.payments[index].paymentNode" v-model="f.payments[index].paymentNode" :clearable="true"
                      />
                    </el-form-item>

                      <el-form-item label="付款比例(%)" :rules="rules.paymentProportion" class="h-elformWrap-fukuan ">
                        <el-input v-model="f.payments[index].paymentProportion"
                                  placeholder="付款比例"
                                  oninput="this.value = this.value && parseInt(this.value);this.value < 0 || this.value>100 && (this.value = 100)"
                                  maxlength="3"
                        ></el-input>
                      </el-form-item>
                    </div>

                  </div>
                </div>


                <el-form-item class="h-elformWrap-1" prop="isAll">
                  <el-switch
                      style="margin-left: 50px;margin-top: -20px"
                      v-model="f.isAll"
                      @change="changeType"
                      active-text="用于全部供应商">
                  </el-switch>
                </el-form-item>
                <div v-if="this.showSupplier">
                  <el-button @click="addProduct()" type="text" size="mini"
                             style="float:right;font-size:20px;margin-right: -5px" icon="el-icon-circle-plus"
                             circle></el-button>

                <div v-for="(listIt, index) in f.suppliers" :key="index" class="h-formBox">
                  <el-button @click="deleteProduct(index)" v-show="index != 0" type="text"
                             style="float:right;font-size:20px;margin-right: -5px;color:crimson;" size="mini"
                             icon="el-icon-remove" circle></el-button>
                  <el-form-item label="供应商名称"  class="h-elformWrap-2" prop="supplierName">
                    <el-select v-model="f.suppliers[index].supplierName" :title="f.suppliers[index].supplierName" remoten
                               filterable  placeholder="请输入" :filter-method="getSupplier"
                               :remote-method="getSupplier" @change="getSupplier($event,index)" :clearable="true">
                      <el-option v-for="(item) in supplierList"
                                 :key="item.username"
                                 :label="item.username"
                                 :value="item.username">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="供应商编码"  class="h-elformWrap-2" prop="supplierCode" >
                    <el-input v-model="f.suppliers[index].supplierCode"  placeholder="输入供应商名称自动带出">
                    </el-input>
                  </el-form-item>
                </div>
              </div>
              </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
              <el-button class="h-btn h-formBtn h-bgwhite" @click="cancel('f')">取消</el-button>
              <el-button class="h-btn h-formBtn h-bgblueQ2" @click="insert(1)">提交
              </el-button>
            </div>
          </el-dialog>



            <el-dialog :close-on-click-modal="false" :visible.sync="dialogFormVisible" class="h-dialog2 yonghu" @close="cancel('f')">
                <div class="h-dialogImg">
                    <div class="h-disTable">
                        <div class="h-tableCell" v-if="this.saveorupdate==1">
                            <h1>新增信息</h1>
                            <p>New</p>
                        </div>
                        <div class="h-tableCell" v-if="this.saveorupdate==2">
                            <h1>修改信息</h1>
                            <p>Update</p>
                        </div>
                    </div>
                </div>
                <div class="h-formLine h-mrb-38">
                    <el-form :model="f" :rules="rules" ref="f"
                             :inline="true" class="demo-ruleForm h-formbLine h-dialogForm dialogForms">
                      <el-form-item label="产品编码" class="h-elformWrap-2" prop="areaCode">
                        <el-select v-model="f.prodcode" remote filterable :filter-method="getProduct" clearable
                                   placeholder="请输入"  :disabled="isCheak"
                                   :remote-method="getProduct" @change="getProduct">
                          <el-option v-for="(item) in productList"
                                     :key="item.prodcode"
                                     :label="item.prodcode"
                                     :value="item.prodcode">
                          </el-option>
                        </el-select>

                      </el-form-item>

                      <el-form-item label="产品型号" class="h-elformWrap-2" prop="areaCode">
                        <el-input  placeholder="输入产品编码自动带出" :v="f.promodel" v-model="f.promodel" :clearable="true" readonly
                        />
                      </el-form-item>

                      <el-form-item label="产品大类" class="h-elformWrap-2" prop="areaCode">
                        <el-input placeholder="输入产品编码自动带出" v-model="f.prodseries" readonly></el-input>
                      </el-form-item>

                      <el-form-item label="二级分类" class="h-elformWrap-2" prop="areaCode">
                        <el-input  placeholder="输入产品编码自动带出" :v="f.procategory" v-model="f.procategory" :clearable="true" readonly
                        />
                      </el-form-item>

                      <el-form-item label="金额" class="h-elformWrap-2" prop="totalPrice">
                        <el-input :v="f.totalPrice" v-model="f.totalPrice" :clearable="true" placeholder="请输入数字" :disabled="isCheak"
                        />
                      </el-form-item>

                      <el-form-item label="币种" class="h-elformWrap-2" prop="currency">
                        <brselect category="YLCurrency" :v="f.currency" v-model="f.currency" :clearable="true" :disabled="isCheak"
                        />
                      </el-form-item>
                      <div>
                        <el-button @click="addFukuan()" type="text" size="mini"
                                   style="float:right;font-size:20px;margin-right: -5px" icon="el-icon-circle-plus" v-if="!isCheak"
                                   circle></el-button>

                        <div v-for="(listIt, index) in f.payments" :key="index" class="h-formBox">
                          <el-button @click="deleteFukuan(index)" v-show="index != 0" type="text"
                                     style="float:right;font-size:20px;margin-right: -5px;color:crimson;" size="mini" v-if="!isCheak"
                                     icon="el-icon-remove" circle></el-button>


                          <div style="width: 100%">
                            <el-form-item prop="paymentNode" label="付款节点" class="h-elformWrap-fukuan " >
                              <brselect category="payment_node" :v="f.payments[index].paymentNode" v-model="f.payments[index].paymentNode" :clearable="true"
                                       :disabled="isCheak"
                              />
                            </el-form-item>

                            <el-form-item label="付款比例(%)" :rules="rules.paymentProportion" class="h-elformWrap-fukuan ">
                              <el-input v-model="f.payments[index].paymentProportion"
                                        placeholder="付款比例"
                                       :disabled="isCheak"
                                        oninput="value=value.replace(/[^\d]/g, '')"
                                        maxlength="3"
                              ></el-input>
                            </el-form-item>
                          </div>

                        </div>
                      </div>

                      <el-form-item label="税率" class="h-elformWrap-2" prop="taxRate">
                        <brselect category="cgshuilv" :v="f.taxRate" v-model="f.taxRate" :clearable="true"  :disabled="isCheak"
                        />
                      </el-form-item>
                      <el-form-item label="描述" class="h-elformWrap-2" prop="des">
                        <el-input :v="f.des" v-model="f.des" :clearable="true" :disabled="isCheak"
                        />
                      </el-form-item>

                        <el-form-item label="供应商名称" class="h-elformWrap-2" prop="supplierName" v-if="this.showSupplier">
                          <el-select v-model="f.supplierName" remote filterable :filter-method="getSupplier" clearable :disabled="isCheak"
                                     placeholder="请输入"
                                     :remote-method="getSupplier" @change="getSupplier">
                            <el-option v-for="(item) in supplierList"
                                       :key="item.username"
                                       :label="item.username"
                                       :value="item.username">
                            </el-option>
                          </el-select>
                        </el-form-item>

                        <el-form-item label="供应商编码" class="h-elformWrap-2" prop="areaCode" v-if="this.showSupplier">
                          <el-input placeholder="输入供应商名称自动带出" :v="f.supplierCode" v-model="f.supplierCode" :clearable="true" readonly
                          />
                        </el-form-item>

                        <el-form-item class="h-elformWrap-1" prop="isAll" v-if="!this.showSupplier" >
                          <el-switch
                              style="margin-left: 50px"
                              v-model="f.isAll"
                              disabled
                              @change="changeType"
                              active-text="用于全部供应商">
                          </el-switch>
                        </el-form-item>

                    </el-form>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button class="h-btn h-formBtn h-bgwhite" @click="cancel('f')">取消</el-button>
                    <el-button class="h-btn h-formBtn h-bgblueQ2" @click="insert(0)" v-if="!isCheak">提交
                    </el-button>
                </div>
            </el-dialog>
          <!--地址信息-->
          <areaSelectNotDetails
              :visible.sync="showdizhiflag"
              v-if="showdizhiflag"
              @choseObj="choseDizhi"
          />
        </div>
    </div>
</template>
<script>
    import ss from '../../../api/SystemService'
    import updownfile from '../../../utils/updownfile'
    import uploaddownexcel from '../../../components/uploaddown/uploaddownexcel'
    import supplierAreaService from "../../../api/dingd/supplierArea"

    export default {
        components: {
            uploaddownexcel,
        },
        data() {
            return {
                //表格
                multipleSelection: [],
                canjobpoint:true,
                isImport:false,
                //导入Excel
                uploaddownexcelflag: false,
                showdizhiflag: false,
                //新增/修改弹窗
                saveorupdate: null,
                areaList:[],
                channelList:[],
                //临时的id
                iditem:'',
                userInfo: {
                    usercode: null,
                    username: null,
                },
                //分页/检索
                q: {
                    jobGroup:null,
                    jobUsercode:null,
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                },
                f:{
                  prodcode:'',
                  promodel:'',
                  prodseries:'',
                  procategory:'',
                  totalPrice:'',
                  currency:'',
                  taxRate:'',
                  paymentNode:'',
                  des:'',
                  suppliers:[],
                  payments:[],
                },
                //链群
                JobGroup: [],
                JobPoint:[],
                //table列表
                tableData: [],
                supplierList:[],
                productList:[],
                paymentNodeList:[],
                //弹窗
                dialogFormVisible: false,
                //弹窗
                dialogFormVisibleAdd: false,
                isCheak:false,
                showSupplier:true,
              rules: {
                supplierName:[{required: true, message: '供应商名称必填', trigger:'input'}],
                supplierCode:[{required: true, message: '供应商编码必填', trigger: 'input'}],
                prodcode:[{required: true, message: '产品编码必填', trigger:['change', ' blur','input']}],
                totalPrice:[{required: true, message: '金额必填', trigger: 'change'}],
                currency:[{required: true, message: '币种必填', trigger: 'change'}],
                paymentNode:[{required: true, message: '付款节点必填', trigger: 'change'}],
                taxRate:[{required: true, message: '税率必填', trigger: 'change'}],
              },
            }
        },
        created() {
            this.query();
            this.channelList = this.$store.getters.dictlist("sales_region");
            this.areaList = this.$store.getters.dictlist("YLRegion");
            this.isImport = this.$store.getters.hasRole('swyl_admin,swyl_shfw');
            this.paymentNodeList = this.$store.getters.dictlist("payment_node");
        },
        methods: {
            //节点筛选可用
            okJobPoint(){
                if(this.q.jobGroup!=null){
                    this.canjobpoint = false;
                    ss.xietongguanli.selectDeptPoint(this.q.jobGroup).then(rd => {
                        this.JobPoint = rd;
                    });
                }else{
                    this.canjobpoint = true;
                    this.q.jobPoint = null;
                }
            },
            //导入Excel
            uploaddownexcelflagbtn() {
                this.uploaddownexcelflag = true;
            },
            uploadExcelFilecallback(rd) {
                this.query();
                this.$msg.msgs(rd.msg);
            },
            //重置检索项
            resetData() {
                this.q.customerCode = null;
                this.q.area = null;
                this.q.channel = null;
                this.q.user = null;
            },
            query() {
                ss.supplierAreaService.selectProductPage(this.q).then(rd => {
                    this.q.total = rd.total;
                    this.tableData = rd.records;
                })
            },
            //新增
            adduser() {
                this.saveorupdate = 1
                this.f.id = null;
                this.f.supplierName = null;
                this.f.supplierCode = null;
                this.f.prodseries = null;
                this.f.procategory = null;
                this.f.promodel = null;
                this.f.prodcode = null;
                this.f.totalPrice = null;
                this.f.currency = null;
                this.f.paymentNode = null;
                this.f.taxRate = null;
                this.f.des = null;
                this.f.suppliers = [{
                  supplierName:'',
                  supplierCode:''
                }]
                this.f.payments = [{
                  paymentNode:'',
                  paymentProportion:''
                }]
                this.dialogFormVisibleAdd = true;
                this.showSupplier = true;
                this.f.isAll = false;
            },
            //弹框关闭
            cancel(formName) {
                this.dialogFormVisible = false;
                this.f.id = null;
                this.f.supplierName = null;
                this.f.supplierCode = null;
                this.f.prodseries = null;
                this.f.procategory = null;
                this.f.promodel = null;
                this.f.prodcode = null;
                this.f.totalPrice = null;
                this.f.currency = null;
                this.f.paymentNode = null;
                this.f.taxRate = null;
                this.f.des = null;
                this.$refs[formName].resetFields();
            },
            //新增
            insert(value) {
                this.f.paymentNode = this.paymentNodes;
                this.f.isAdd = value;
                ss.supplierAreaService.updateByProductId(this.f).then(rd => {
                    this.query();
                    this.$msg.msgs(rd.msg);
                    this.dialogFormVisible = false;
                    this.dialogFormVisibleAdd = false;
                })
            },
            //勾选
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            //删除
            handleDelete(value) {
                this.$msg.confirm("确认删除?", () => {
                    ss.xietongguanli.deleteDept(value.id).then(rd => {
                        this.query();
                        this.$msg.msgs(rd.msg);
                    });
                });
            },
            //修改
            update(value) {
              this.saveorupdate = 2;
                ss.supplierAreaService.selectProductById(value.id).then(rd => {
                    this.dialogFormVisible = true;
                    this.isCheak = false;
                    this.f = rd.obj;
                    if(this.f.isAll == 'true'){
                      this.showSupplier = false;
                      this.f.isAll = true;
                    }
                })
            },

            //查看
            cheak(value) {
              this.saveorupdate = 2;
              this.isCheak = true;
              ss.supplierAreaService.selectProductById(value.id).then(rd => {
                this.dialogFormVisible = true;
                this.f = rd.obj;
                if(this.f.isAll == 'true'){
                  this.showSupplier = false;
                  this.f.isAll = true;
                }
              })
            },
            //根据用户编码获取用户信息
            getUserName(){
                var usercode = this.f.jobUsercode;
                ss.UserService.selectById(usercode).then(rd => {
                    console.log("getUserName",rd)
                    this.f={
                        id:this.iditem,
                        jobUsercode:rd.obj.usercode,
                        jobUsername:rd.obj.username,
                        jobGroup:this.f.jobGroup,
                    }
                    console.log("getUserName123",rd)
                })
            },
            deleteSelete() {
              var idlist = [];
              this.multipleSelection.forEach(element => {
                idlist.push(element.id);
              });
              console.log(idlist)
              this.deleteSingle(idlist)
            },
            deleteSingle(id) {
              console.log("id", id)
              var data = id
              this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                ss.supplierAreaService.deleteProductList(data).then(res => {
                  console.log(res)
                  if (res.f == true) {
                    this.$message({
                      type: 'success',
                      message: '删除成功!'
                    });
                    this.query()
                  } else {
                    this.$message.error(res.msg);
                  }
                })

              }).catch(() => {
                this.$message({
                  type: 'info',
                  message: '已取消删除'
                });
              });

            },
            //批量导出
            exportExcel() {
                updownfile.down("/api/swyl/v1/demo/bscSupplierProductCompare/downloadExcel", this.q, "get",);
            },
            //选择地址
            selectAreadialog() {
              this.showdizhiflag = true;
            },
            choseDizhi(obj) {
              console.log("obj",obj);
              this.f.areaName = obj.quobj.namepath;
              this.f.areaId = obj.quobj.code;
              this.showdizhiflag = false;
            },
            getSupplier(value, index){
                ss.supplierAreaService.selectByUserName(value).then(res => {
                  console.log(res)
                  this.supplierList = res.obj
                  this.f.suppliers[index].supplierName = res.obj[0].username
                  this.f.suppliers[index].supplierCode = res.obj[0].usercode
                })
            },
            getProduct(value){
              ss.supplierAreaService.selectByProduct(value).then(res => {
                console.log(res)
                this.productList = res.msg
                this.f.prodcode = res.msg[0].prodcode
                this.f.promodel = res.msg[0].promodel
                this.f.prodseries = res.msg[0].prodseries
                this.f.procategory = res.msg[0].procategory
              })
            },
            getPaymentNode(value){
              var jsonObj = value
              var jStr = '';
              for(var item in jsonObj){
                jStr += jsonObj[item]+",";
              }
              this.paymentNodes= jStr.substring(0, jStr.lastIndexOf(','))
            },
            changeType(value){

              this.showSupplier = !value;
              this.f.suppliers = [];
                console.log(value);
            },
            deleteProduct(index) {
              this.f.suppliers.splice(index, 1)
              //进行强制数据渲染
              this.$forceUpdate();
            },
            addProduct() {
              this.f.suppliers.push({
                supplierName: '',
                supplierCode: ''
              })
              //进行强制数据渲染
              this.$forceUpdate();
            },
            addFukuan(){
              this.f.payments.push({
                paymentNode: '',
                paymentProportion: ''
              })
              //进行强制数据渲染
              this.$forceUpdate();
            },
            deleteFukuan(index) {
              this.f.payments.splice(index, 1)
              //进行强制数据渲染
              this.$forceUpdate();
            },
        }
    }
</script>

<style>
    .yonghu .h-formbLine .h-elformWrap-2 {
        width: 50%;
    }

    .yonghu .h-formbLine .h-elformWrap-fukuan {
      width: 45%;
    }

    .yonghu .h-dialogForm .h-elformWrap-2 .el-form-item__label {
        width: 41%;
    }

    .yonghu .h-dialogForm .h-elformWrap-2 .el-form-item__content {
        width: 59%;
    }

    .yonghu .h-formbLine .el-form-item__content .el-select {
        width: 100% !important;
    }

    .yonghu .h-formbLine .el-form-item__content {
      width: 60%;
      line-height: 0.28rem;
      font-size: 0.18rem;
      vertical-align: middle;
    }
    .yonghu .h-formbLine .el-form-item__label {
      width: 40%;
    }
    .h-dialog3.dialogFormVisible3 .el-dialog__body {
        padding: 0 0.5rem 0.3rem 0.5rem;
    }


    .h-dialog3.dialogFormVisible3 .el-dialog__body .el-upload--picture-card {
        width: 100%;
        height: 103px;
        border: 1px dashed #7c9ec0;
        background: 0;
        line-height: 103px;
        margin-top: 20px;
        color: #4b4b4b;
        font-size: 18px;
    }
    .el-table tbody td:last-child{
        border-left: 1px solid #c2d2db;
    }
</style>
